export default {"src":"/_next/static/media/features-payment-gateways.d251a082.svg","height":59,"width":58,"blurWidth":0,"blurHeight":0};